export const CompaniesWithoutKeyContactsResultConstants = {
    FETCH_COMPANIES_WITHOUT_KEY_CONTACTS_RESULTS_PENDING: 'FETCH_COMPANIES_WITHOUT_KEY_CONTACTS_RESULTS_PENDING',
    FETCH_COMPANIES_WITHOUT_KEY_CONTACTS_RESULTS_GET_LIST_SUCCESS: 'FETCH_COMPANIES_WITHOUT_KEY_CONTACTS_RESULTS_GET_LIST_SUCCESS',
    FETCH_COMPANIES_WITHOUT_KEY_CONTACTS_RESULTS_RESULT_ERROR: 'FETCH_COMPANIES_WITHOUT_KEY_CONTACTS_RESULTS_RESULT_ERROR'
};

